import React from 'react';
import { Title, SubTitle } from './CiTradeHeader.style';
import Breadcrumb from '../../../../Utils/Breadcrumb';

const CiTradeHeader = () => {
  const breadcrumbItems = [
    { name: 'Master Data Records', path: '/viewEditReport' },
    { name: 'Analytics Home', path: '/ncf-reporting' },
    { name: 'C&I Trades' },
  ];

  return (
    <div style={{ marginTop: '46px' }}>
      <Breadcrumb items={breadcrumbItems} />
      <Title data-testid='title'>C&I Trades</Title>
      <SubTitle data-testid='subtitle'>C&I Trades</SubTitle>
    </div>
  );
};

export default CiTradeHeader;
